import React from "react";
import { useDispatch } from "react-redux";
import { useFormContext, useFormState } from "react-hook-form";
import PropTypes from "prop-types";

import Button from "@mui/material/Button";
import FileCopy from "@mui/icons-material/FileCopyOutlined";

import { showNotification } from "../../../../features/core/slices/notification.slice";
import {
  copyAddressFromSource,
  validateAddressFields,
} from "../../services/form.service";

function CopyAddressBtn(props) {
  const {
    fieldProps,
    getValues,
    setValue,
    control,
    trigger,
    datagridFormState,
    disabled,
  } = props;
  const dispatch = useDispatch();
  const { errors } = useFormState({ control });
  const { tags, label, properties } = fieldProps;

  // Source address fields live on the main form even when this button renders inside a
  // DataGrid record (properties.reference === "form"), so read/validate from the main form.
  const {
    control: mainFormControl,
    trigger: mainFormTrigger,
    getValues: mainFormGetValues,
  } = useFormContext();
  const { errors: mainFormErrors } = useFormState({ control: mainFormControl });
  const isDgWithFormReference =
    Boolean(datagridFormState) && properties?.reference === "form";

  const onBtnClick = () => {
    const source = properties?.source || "";
    if (tags && tags.length && properties) {
      const sourceTrigger = isDgWithFormReference ? mainFormTrigger : trigger;
      const sourceErrors = isDgWithFormReference ? mainFormErrors : errors;
      const sourceGetValues = isDgWithFormReference
        ? mainFormGetValues
        : getValues;

      tags.forEach((item) => sourceTrigger(item));
      setTimeout(() => {
        const errorMsg = validateAddressFields({
          tags,
          errors: sourceErrors,
          source,
          btnType: "copy",
        });
        if (errorMsg)
          dispatch(
            showNotification({ type: "warning", msg: errorMsg, show: true })
          );
        else
          copyAddressFromSource(
            properties,
            sourceGetValues(),
            setValue,
            trigger
          );
      }, 10);
    }
  };

  return (
    <Button
      variant="contained"
      onClick={onBtnClick}
      startIcon={<FileCopy />}
      disabled={disabled}
    >
      {label}
    </Button>
  );
}
CopyAddressBtn.propTypes = {
  fieldProps: PropTypes.shape({
    label: PropTypes.string.isRequired,
    tags: PropTypes.arrayOf(PropTypes.string).isRequired,
    properties: PropTypes.shape({
      source: PropTypes.string,
      // present only when copying a main-form address into a DataGrid record
      reference: PropTypes.string,
    }).isRequired,
  }).isRequired,
  control: PropTypes.shape({}).isRequired,
  getValues: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  trigger: PropTypes.func.isRequired,
  datagridFormState: PropTypes.shape({}),
  disabled: PropTypes.bool.isRequired,
};
CopyAddressBtn.defaultProps = {
  datagridFormState: undefined,
};

export default CopyAddressBtn;
